export default function Logo({ size = "md" }) {
  const fontSize = size === "lg" ? 22 : 16;
  const markSize = size === "lg" ? 18 : 14;
  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 10,
        fontWeight: 600,
        fontSize,
        letterSpacing: "-0.02em",
      }}
    >
      <span
        style={{
          width: markSize,
          height: markSize,
          background: "#111",
          borderRadius: 3,
          display: "inline-block",
          position: "relative",
        }}
      >
        <span
          style={{
            position: "absolute",
            inset: 3,
            background: "#fff",
            borderRadius: 1,
          }}
        />
      </span>
      <span>Parapet</span>
    </div>
  );
}
